import PassengersSeats from './passengers-seats-component';

import './passengers-seats.scss';

const MODULE_NAME = 'app.flight.passengers-seats';
const module = angular.module(MODULE_NAME, [])
    .directive(PassengersSeats.DIRECTIVE_NAME, PassengersSeats);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/passengers-seats/passengers-seats-module.js